//
//
//
//
//
//
//
//


export default {
    data () {
        return {
            imgsrc_1: 'https://cdn.vip-wifi.com/fangchan/config/pages/learn_layout/learn-1.png?v=' + new Date().getTime(),
            imgsrc_2: 'https://cdn.vip-wifi.com/fangchan/config/pages/learn_layout/learn-2.png?v=' + new Date().getTime(),
            imgsrc_3: 'https://cdn.vip-wifi.com/fangchan/config/pages/learn_layout/learn-3.png?v=' + new Date().getTime(),
        }
    },
    components: {

    },
    mounted () {
        const { sub_page } = this.$route.query
        if (sub_page) {
            wx.navigateTo({
                url: decodeURIComponent(sub_page)
            })
        }
    },
}
